import { render, staticRenderFns } from "./CSelect.vue?vue&type=template&id=332e560e&scoped=true"
import script from "./CSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./CSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CSelect.vue?vue&type=style&index=0&id=332e560e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332e560e",
  null
  
)

export default component.exports